import { render, staticRenderFns } from "./AuthorizationField.vue?vue&type=template&id=0287ed1a"
import script from "./AuthorizationField.vue?vue&type=script&lang=js"
export * from "./AuthorizationField.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationField.vue?vue&type=style&index=0&id=0287ed1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports